export default __webpack_public_path__ + "static/media/chatr-blue.a7ab9573.png";